import * as React from 'react'
import { useState, useEffect } from "react";

import {
    Column,
    ColumnDef,
    flexRender,
    getCoreRowModel,
    createColumnHelper,
    getFilteredRowModel,
    getPaginationRowModel,
    Table,
    useReactTable,
} from '@tanstack/react-table'
import { PlannedOrder } from './assortmentPlanningProductTable';

const defaultData: PlannedOrder[] = [
    {
        orderId: "12345",
        quantity: 1,
        lineItems: []
    }
]

const columnHelper = createColumnHelper<PlannedOrder>()

const columns = [
    columnHelper.accessor('orderId', {
        id: 'orderId',
        cell: info => info.getValue(),
        header: () => <span>Order Id</span>,
        footer: info => info.column.id,
    })
]

const AssortmentPlanningProductDetailTable = (props: { orders: Array<PlannedOrder> | undefined, onCurrentProductChanged: any, onCurrentCellChanged: any }) => {
    const [data, setData] = useState(() => [...defaultData])
    //  const [rowSelection, setRowSelection] = useState({})
    // const [rowInfo, setRowInfo] = useState<Product>()
    const table = useReactTable({
        data,
        columns,
        enableRowSelection: true, //enable row selection for all rows
        // enableRowSelection: row => row.original.age > 18, // or enable row selection conditionally per row
        // onRowSelectionChange: setRowSelection,
        getCoreRowModel: getCoreRowModel(),
        debugTable: true,
    })

    const onRowClicked = (event: any) => {
        //  setRowInfo(event);
        props.onCurrentProductChanged(event);
    }

    const onCellClicked = (event: any) => {
        var period = -1;

        switch (event) {
            case "period1":
                period = 1;
                break;
            case "period2":
                period = 2;
                break;
            case "period3":
                period = 3;
                break;
            case "period4":
                period = 4;
                break;
            case "period5":
                period = 5;
                break;
            case "period6":
                period = 6;
                break;
        }
        props.onCurrentCellChanged(period);
    }

    useEffect(() => {
        setData(props.orders || []);
    }, [props.orders])

    return (
        <table border={1}>
            <thead>
                {table.getHeaderGroups().map(headerGroup => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map(header => (
                            <th key={header.id}>
                                {header.isPlaceholder
                                    ? null
                                    : flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                    )}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody>
                {table.getRowModel().rows.map(row => {
                    return (
                        <tr key={row.id} onClick={() => onRowClicked(row.original)}>
                            {row.getVisibleCells().map(cell => {
                                return (
                                    <td key={cell.id} onClick={() => onCellClicked(cell.column.id)}>
                                        {flexRender(
                                            cell.column.columnDef.cell,
                                            cell.getContext()
                                        )}
                                    </td>
                                )
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </table>
    );
}

export default AssortmentPlanningProductDetailTable;